<template>
  <div class="accordion__container">
    <div class="accordion__body">
      <div class="accordion__tabs">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          :style="cssProps"
          class="accordion__tab"
        >
          <accordion
            :item="item"
            :idx="idx"
            :accordion-key="accordionKey"
            ref="accordion__input"
            @toggle="toggleRadio"
            :active-accordion="activeAccordion"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from './Accordion'

export default {
  data() {
    return {
      accordionKey: null,
      activeAccordion: '',
    }
  },
  components: {
    Accordion,
  },
  props: {
    textColorClosed: {
      type: String,
      default: "",
    },
    textColorOpen: {
      type: String,
      default: "",
    },
    backgroundColorClosed: {
      type: String,
      default: "",
    },
    backgroundColorOpen: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    this.accordionKey = Math.floor(Math.random() * 1000);
  },
  computed: {
    cssProps() {
      return {
        "--background-color-closed": this.backgroundColorClosed
          ? this.backgroundColorClosed
          : "var(--primary)",
        "--background-color-open": this.backgroundColorOpen
          ? this.backgroundColorOpen
          : "var(--primary)",
        "--text-color-open": this.textColorOpen
          ? this.textColorOpen
          : "var(--secondary)",
        "--text-color-closed": this.textColorClosed
          ? this.textColorClosed
          : "var(--secondary)",
      };
    },
  },
  methods: {
    toggleRadio(value) {
      this.activeAccordion = value
    }
  }
}
</script>

<style lang="scss">
.accordion__container {
  // General
  .accordion__input {
    position: fixed;
    opacity: 0;
    z-index: -1;
  }
  // Layout
  .accordion__container {
    display: flex;
    .accordion__body {
      flex: 1;
    }
  }
  /* Accordion styles */
  .accordion__tabs {
    overflow: hidden;
  }
  .accordion__tab {
    width: 100%;
    color: var(--text-color-closed);
    overflow: hidden;
    &-label {
      display: flex;
      justify-content: space-between;
      padding: 1em;
      background-color: var(--background-color-closed);
      font-weight: bold;
      cursor: pointer;
      /* Icon */
      //&:hover {
      //  background: $color;
      //}
    }
    &-content {
      max-height: 0;
      padding: 0 1em;
      color: transparent;
      background: white;
      transition: all 0.35s;
      a {
        color: transparent;
      }
      p:last-of-type {
        margin-bottom: 0;
      }
    }
    &-close {
      display: flex;
      justify-content: flex-end;
      padding: 1em;
      font-size: 0.75em;
      background-color: var(--background-color-closed);
      cursor: pointer;
      //&:hover {
      //  background: $color;
      //}
    }
  }

  .accordion__tab-label {
    span {
      display: flex;
      align-items: center;
      gap: var(--link-box-grid-gap)
    }
  }
  .accordion__tab-content { word-break: break-word; }
  // :checked
  .accordion__input:checked {
    + .accordion__tab-label {
      background-color: var(--background-color-open);
      opacity: 0.6;
      &::after {
        transform: rotate(90deg);
      }
      > span {
        color: var(--text-color-open);
      }
    }
    ~ .accordion__tab-content {
      color: #000;
      max-height: 100vh;
      padding: 1em;
      a {
        color: var(--primary);
      }
    }
  }
}
</style>
